import { createApi } from "@reduxjs/toolkit/query/react";
import { extendedBaseQuery } from "../basequery";

export const plansApi = createApi({
  reducerPath: "plansApi",
  baseQuery: extendedBaseQuery,
  tagTypes: ["plans"],
  endpoints: (builder) => ({
    getPlans: builder.query({
      query: (params) => {
        const query = {};
        if (params?.skip) query.skip = params.skip;
        if (params?.limit) query.limit = params.limit;
        if (params?.search) query.search = params.search;
        if (params?.filter) query.filter = params.filter;
        if (params?.sortBy) query.sortBy = params.sortBy;
        if (params?.orderBy) query.orderBy = params.orderBy;
        const queryString = new URLSearchParams(query).toString();
        return {
          url: `plans/all${queryString ? `?${queryString}` : ""}`,
          method: "GET",
        };
      },
      providesTags: ["plans"],
    }),
    activatePlan: builder.mutation({
      query: (body) => ({
        url: "plans/activatePlan",
        method: "POST",
        body,
      }),
      invalidatesTags: ["plans"],
    }),
    createPlan: builder.mutation({
      query: (body) => ({
        url: "plans/create",
        method: "POST",
        body,
      }),
    }),
    updatePlan: builder.mutation({
      query: (body) => {
        const { id, ...restBody } = body;
        return {
          url: `plans/updatePlan/${id}`,
          method: "PATCH",
          body: restBody,
        };
      },
      invalidatesTags: ["plans"],
    }),
  }),
});

export const {
  useGetPlansQuery,
  useActivatePlanMutation,
  useCreatePlanMutation,
  useUpdatePlanMutation,
} = plansApi;